var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgShipping = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 17,
  fill: "none",
  viewBox: "0 0 17 17"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  fillRule: "evenodd",
  d: "M5.941 11.777a1.839 1.839 0 1 1-3.677-.046h-.301a1 1 0 0 1-1-1V4.384a1 1 0 0 1 1-1h7.794a1 1 0 0 1 1 1v1.29h2.077a2.5 2.5 0 0 1 2.5 2.5v3.055a.5.5 0 0 1-.5.5H13.37v.048a1.839 1.839 0 1 1-3.677-.046H5.941zM2.063 4.484v6.147h.601a1.84 1.84 0 0 1 1.438-.693c.583 0 1.102.27 1.439.693h4.116V4.484zm8.704 2.29h.758v1.448a.8.8 0 0 0 .8.8h1.91v1.607h-1.267a1.835 1.835 0 0 0-2.2-.525zm1.859 1.148V6.774h.208a1.4 1.4 0 0 1 1.378 1.148zm-1.095 4.594a.739.739 0 1 0 0-1.478.739.739 0 0 0 0 1.478m-6.69-.739a.739.739 0 1 1-1.477 0 .739.739 0 0 1 1.477 0",
  clipRule: "evenodd"
})));
export { SvgShipping as ReactComponent };